import React from 'react';
import classnames from 'classnames';
import {Banner, Button, Radio, Text} from '@albert-io/atomic';

import './license-status.scss';

const LICENSED_TRAITS = ['Access to all Albert content included in your license', 'Students will occupy license seats'];

const UNLICENSED_TRAITS = [
  'Access to all adaptive content only',
  'Students will not occupy license seats'
];

interface LicenseStatusCardProps extends PropsWithClassNameOptional {
  isLicensed: boolean;
  selected?: boolean;
  readonly?: boolean;
  onClick?: () => void;
  warning?: string;
  disabled?: boolean;
}

export const LicenseStatusCard = ({
  isLicensed,
  className,
  selected = false,
  readonly = false,
  onClick,
  warning,
  disabled = false
}: LicenseStatusCardProps) => {
  const listItems = isLicensed ? LICENSED_TRAITS : UNLICENSED_TRAITS;

  const disableRadio = disabled || !!warning;

  return (
    <Button
      variant='outlined'
      color={selected ? 'primary' : 'secondary'}
      onClick={disableRadio ? undefined : onClick}
      className={classnames(
        'flex items-start! justify-start! p-x1-half! font-normal!',
        {
          'cursor-pointer': !readonly,
          'cursor-not-allowed!': disableRadio,
          'license-status__card--selected': selected,
          'license-status__card--readonly': readonly
        },
        className
      )}
    >
      {!readonly && (
        <Radio
          name='license-status'
          value={isLicensed ? 'licensed' : 'unlicensed'}
          checked={selected}
          onChange={() => onClick?.()}
          disabled={disableRadio}
          onClick={(e) => e.stopPropagation()}
          className='license-status__radio mr-x1-half'
        />
      )}
      <div className='text-start'>
        <Text size='m' color={selected ? 'info' : 'primary'}>
          {isLicensed ? 'Licensed' : 'Unlicensed'}
        </Text>
        <ul className='m-x0 mt-x0-half flex list-disc flex-col gap-x0-half pl-x3'>
          {listItems.map((item) => (
            <li key={item}>
              <Text size='s' color={selected ? 'info' : 'secondary'}>
                {item}
              </Text>
            </li>
          ))}
        </ul>
        {warning && (
          <Banner type='warning' className='mt-x1' border={false}>
            <Banner.Icon icon='warning' iconStyle='regular' className='self-center' />
            <Text size='s' color='warning'>
              {warning}
            </Text>
          </Banner>
        )}
      </div>
    </Button>
  );
};

export default LicenseStatusCard;
